import { ChangeDetectorRef, Component, HostListener } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SharedService } from '../../../services/shared.service';

@Component({
  selector: 'app-employee-overtime',
  standalone: false,
  templateUrl: './employee-overtime.component.html',
  styleUrl: './employee-overtime.component.css'
})
export class EmployeeOvertimeComponent {
  shareObject: any = {
    selectedRows: new Set(),
    lastSelectedIndex: null,
    employeeSelected: [],
    component: '/employee_overtime',
    listURL: '/user/employee/overtime',
    addURL: '/user/employee/overtime/create',
    editURL: '/user/employee/overtime/edit',
    deletedURL: '/user/employee/overtime/deleted',
  };
  formHandle!: FormGroup;
  filterForm!: FormGroup;
  constructor(
    public sharedService: SharedService,
    private translate: TranslateService,
    private router: Router,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
  ) {
    this.shareObject.options = { filter: {}, page: 1, limit: this.sharedService.env.pageSize[0] };
    this.activatedRoute.params.subscribe((params) => {
      if (params['id']) {
        this.shareObject.id = params['id'];
      }
    })
  }
  ngOnInit(): void {
    this.shareObject.data = this.activatedRoute.snapshot.data;
    let dateGMT = Date.now() + this.sharedService.env.timeoffset;
    this.formHandle = this.fb.group({
      start: [new Date(dateGMT).toISOString().slice(0, 16), [Validators.required]],
      end: [new Date(dateGMT).toISOString().slice(0, 16), [Validators.required]],
      status: [2]
    })
    this.filterForm = this.fb.group({
      limit: [this.sharedService.env.pageSize[0]],
      startDate: [''],
      endDate: [''],
      keyword: [''],
    })
    if (this.shareObject.data.type == 'edit') {
      this.getItem();
    } else if (this.shareObject.data.type == 'list' || this.shareObject.data.type == 'deleted') {
      this.getItems();
    }
    if (['add', 'edit'].includes(this.shareObject.data.type)) {
      this.getUsers();
    }
  }
  getUsers(e: any = null, page: any = 1) {
    let keyword = e?.target?.value ?? null;
    let payload: any = { limit: this.sharedService.env.pageSize[0], page };
    if (keyword) {
      payload.keyword = keyword
    }
    this.sharedService.callApi('/users/get_user_workcalendar', payload).subscribe({
      next: (res: any) => {
        this.shareObject.employees = {
          data: res.data.data.map((e: any) => {
            e.checked = this.shareObject.employeeSelected.includes(e.id);
            return e;
          }),
          pagination: res.data.pagination
        }

      },
      error: (err: any) => {
        this.sharedService.toast({
          title: this.translate.instant('error'),
          message: err.error.message,
          type: 'danger',
        });
      }
    })
  }
  changePage(page: any) {
    this.getUsers(null, page);
  }
  selectUser(id: any) {
    if (this.shareObject.employeeSelected.includes(id)) {
      this.shareObject.employeeSelected = this.shareObject.employeeSelected.filter((e: any) => e != id);
    } else {
      this.shareObject.employeeSelected.push(id);
    }
    this.shareObject.employees.data = this.shareObject.employees.data.map((e: any) => {
      if (e.id == id) {
        e.checked = !e.checked;
      }
      return e;
    })
    console.log(this.shareObject.employeeSelected)
  }
  getItems() {
    this.shareObject.filterBox = false;
    this.shareObject.isLoading = true;
    let path = this.shareObject.data.type == 'deleted' ? `${this.shareObject.component}/list_deleted` : `${this.shareObject.component}/list`;
    this.sharedService.callApi(path, this.shareObject.options).subscribe({
      next: (res: any) => {
        this.shareObject.isLoading = false
        this.shareObject.items = res.data.data.map((e: any) => {
          e.statusText = e.status == 1 ? this.translate.instant('status_waiting') : e.status == 2 ? this.translate.instant('status_approved') : this.translate.instant('status_rejected');
          e.editURL = `${this.shareObject.editURL}/${e?.id}`
          return e;
        })
        this.shareObject.pagination = res.data.pagination;
      },
      error: (err: any) => {
        this.shareObject.isLoading = false
        this.sharedService.toast({
          title: this.translate.instant('error'),
          message: err.error.message,
          type: 'danger',
        });
      }
    })
  }
  getItem() {
    this.shareObject.isLoading = true
    this.sharedService.callApi(`${this.shareObject.component}/get`, { id: this.shareObject.id }).subscribe({
      next: (res: any) => {
        this.shareObject.employee = res.data;
        let start = new Date(new Date(res.data.start).getTime() + this.sharedService.env.timeoffset).toISOString().slice(0, 16);
        let end = new Date(new Date(res.data.end).getTime() + this.sharedService.env.timeoffset).toISOString().slice(0, 16);
        console.log(`patch start`, start)
        this.formHandle.patchValue({ start, end, status: res.data.status })
        this.shareObject.employeeSelected = res.data.employees.map((e: any) => e.id);
      },
      error: (err: any) => {
        this.shareObject.isLoading = false
        this.sharedService.toast({
          title: this.translate.instant('error'),
          message: err.error.message,
          type: 'danger',
        });
      },
      complete: () => {
        this.shareObject.isLoading = false
      }
    })
  }
  addItem() {
    let payload = {
      start: new Date(this.formHandle.value.start),
      end: new Date(this.formHandle.value.end),
      status: this.formHandle.value.status,
      employees: this.shareObject.employeeSelected,
    }
    this.shareObject.isLoading = true
    this.sharedService.callApi(`${this.shareObject.component}/add`, payload).subscribe({
      next: (res: any) => {
        if (res.success) {
          this.shareObject.isLoading = false
          this.sharedService.toast({
            title: this.translate.instant('success'),
            message: this.translate.instant('add_success'),
            type: 'success',
          });
          this.router.navigate([this.shareObject.listURL]);
        } else {
          this.shareObject.isLoading = false
          this.sharedService.toast({
            title: this.translate.instant('error'),
            message: res.message,
            type: 'danger',
          });
        }
      },
      error: (err: any) => {
        this.shareObject.isLoading = false
        this.sharedService.toast({
          title: this.translate.instant('error'),
          message: err.error.message,
          type: 'danger',
        });
      }
    })
  }
  updateItem() {
    this.shareObject.isLoading = true
    let start = new Date(this.formHandle.value.start).getTime();
    let end = new Date(this.formHandle.value.end).getTime();
    console.log('start', start)
    let payload = {
      id: this.shareObject.id,
      start,
      end,
      status: this.formHandle.value.status,
      employees: this.shareObject.employeeSelected,
    }
    this.sharedService.callApi(`${this.shareObject.component}/update`, payload).subscribe({
      next: (res: any) => {
        this.shareObject.isLoading = false
        this.sharedService.toast({
          title: this.translate.instant('success'),
          message: this.translate.instant('update_success'),
          type: 'success',
        });
        // this.router.navigate(['/user/employee/group']);
      },
      error: (err: any) => {
        this.shareObject.isLoading = false
        this.sharedService.toast({
          title: this.translate.instant('error'),
          message: this.translate.instant('update_failed'),
          type: 'danger',
        });
      }
    })
  }
  onSubmit() {
    this.sharedService.validateForm(this.formHandle);
    if (this.shareObject.data.type == 'edit') {
      this.updateItem()
    }
    else if (this.shareObject.data.type == 'add') {
      this.addItem()
    } else {
      this.request();
    }
  }
  clear() {
    this.shareObject.options = { filter: {}, page: 1, limit: this.sharedService.env.pageSize[0] };
    this.filterForm.reset();
    this.filterForm.patchValue({
      limit: this.sharedService.env.pageSize[0],
      startDate: '',
      endDate: '',
    })
    this.shareObject.selectedRows.clear();
    this.getItems();
  }
  deleteItem(ids: string[]) {
    this.sharedService.confirm({
      title: this.translate.instant('confirm'),
      message: this.translate.instant('confirm_delete'),
    }).then((confirmed: any) => {
      if (confirmed) {
        console.log('confirmed')
        this.shareObject.isLoading = true
        this.sharedService.callApi(`${this.shareObject.component}/delete_many`, { ids }).subscribe({
          next: (res: any) => {
            this.shareObject.isLoading = false
            this.sharedService.toast({
              title: this.translate.instant('success'),
              message: this.translate.instant('delete_success'),
              type: 'success',
            });
            this.shareObject.items = this.shareObject.items.filter((item: any) => !ids.includes(item.id));
          },
          error: (err: any) => {
            this.shareObject.isLoading = false
            this.sharedService.toast({
              title: this.translate.instant('error'),
              message: err.error.message,
              type: 'danger',
            });
          }
        })
      }
    })
  }
  onPageChange(page: any) {
    this.shareObject.options.page = page;
    this.getItems();
  }
  limitFilter(limit: any) {
    this.shareObject.options.limit = Number(limit.value);
    this.getItems();
  }
  softDeleteItem(ids: any) {
    ids = this.handleIndextoId(ids);
    this.sharedService.confirm({
      title: this.translate.instant('confirm'),
      message: this.translate.instant('confirm_delete'),
    }).then((confirmed: any) => {
      if (confirmed) {
        console.log('confirmed')
        this.shareObject.isLoading = true
        this.sharedService.callApi(`${this.shareObject.component}/delete_soft_many`, { ids }).subscribe({
          next: (res: any) => {
            this.shareObject.isLoading = false
            this.sharedService.toast({
              title: this.translate.instant('success'),
              message: this.translate.instant('delete_success'),
              type: 'success',
            });
            this.shareObject.items = this.shareObject.items.filter((item: any) => !ids.includes(item.id));
            this.shareObject.selectedRows.clear();
          },
          error: (err: any) => {
            this.shareObject.isLoading = false
            this.sharedService.toast({
              title: this.translate.instant('error'),
              message: err.error.message,
              type: 'danger',
            });
          }
        })
      }
    })
  }
  restoreItem(ids: any) {
    ids = this.handleIndextoId(ids);
    this.sharedService.confirm({
      title: this.translate.instant('confirm'),
      message: this.translate.instant('confirm_restore'),
    }).then((confirmed: any) => {
      if (confirmed) {
        console.log('confirmed')
        this.shareObject.isLoading = true
        this.sharedService.callApi(`${this.shareObject.component}/restore_many`, { ids }).subscribe({
          next: (res: any) => {
            this.shareObject.isLoading = false
            this.sharedService.toast({
              title: this.translate.instant('success'),
              message: this.translate.instant('restore_success'),
              type: 'success',
            });
            this.shareObject.items = this.shareObject.items.filter((item: any) => !ids.includes(item.id));
            this.shareObject.selectedRows.clear();
          },
          error: (err: any) => {
            this.shareObject.isLoading = false
            this.sharedService.toast({
              title: this.translate.instant('error'),
              message: err.error.message,
              type: 'danger',
            });
          }
        })
      }
    })
  }
  filter(key: any, value: any) {
    if (!value) {
      this.filterForm.patchValue({ [key]: null });
      delete this.shareObject.options.filter[key];
    } else {
      this.shareObject.options.filter[key] = value;
    }
    this.shareObject.options.page = 1;
    this.onSearch();
  }
  onSearch() {
    if (this.filterForm.value.startDate && this.filterForm.value.startDate != '') {
      this.shareObject.options.filter.start = { $gte: new Date(new Date(this.filterForm.value.startDate).setHours(0, 0, 0, 0)) };
    }
    if (this.filterForm.value.endDate && this.filterForm.value.endDate != '') {
      this.shareObject.options.filter.end = { $lte: new Date(new Date(this.filterForm.value.endDate).setHours(23, 59, 59, 999)) };
    }
    this.shareObject.options.keyword = this.filterForm.value['keyword'] ?? undefined;
    this.shareObject.options.page = 1;
    this.shareObject.options.limit = this.filterForm.value['limit'] ?? this.sharedService.env.pageSize[0];
    this.getItems();
  }
  isAllSelected(data: any[] = []): boolean {
    return this.shareObject.selectedRows.size === data.length;
  }
  toggleSelectAll(event: Event, data: any[]) {
    const isChecked = (event.target as HTMLInputElement).checked;

    if (isChecked) {
      data.forEach((_, index) => this.shareObject.selectedRows.add(index));
    } else {
      this.shareObject.selectedRows.clear();
    }
  }
  selectRow(event: MouseEvent, index: number) {
    //check nếu index đã có trong selectedRows thì bỏ chọn
    if (this.shareObject.selectedRows.has(index)) {
      this.toggleRowSelection(index);
      return;
    }
    if (event.ctrlKey || event.metaKey) {
      // Ctrl/Cmd click: toggle selection
      this.toggleRowSelection(index);
    } else if (event.shiftKey && this.shareObject.lastSelectedIndex !== null) {
      // Shift click: select range
      this.selectRange(this.shareObject.lastSelectedIndex, index);
    } else {
      // Regular click: single selection
      this.selectSingleRow(index);
    }
    this.shareObject.lastSelectedIndex = index;
  }
  toggleRowSelection(index: number) {
    if (this.shareObject.selectedRows.has(index)) {
      this.shareObject.selectedRows.delete(index);
    } else {
      this.shareObject.selectedRows.add(index);
    }
  }
  selectSingleRow(index: number) {
    this.shareObject.selectedRows.clear();
    this.shareObject.selectedRows.add(index);
  }
  selectRange(start: number, end: number) {
    this.shareObject.selectedRows.clear();
    const [from, to] = [Math.min(start, end), Math.max(start, end)];
    for (let i = from; i <= to; i++) {
      this.shareObject.selectedRows.add(i);
    }
  }
  handleIndextoId(idexes: any) {
    const selectedIds = Array.from(idexes).map((index: any) => this.shareObject.items[index].id);
    return selectedIds;
  }
  request() {
    this.sharedService.callApi(`${this.shareObject.component}/request`, this.formHandle.value).subscribe({
      next: (res: any) => {
        this.shareObject.isLoading = false
        this.sharedService.toast({
          title: this.translate.instant('success'),
          message: this.translate.instant('toast_created'),
          type: 'success',
        });
        this.router.navigate(['/user/profile']);
      },
      error: (err: any) => {
        this.shareObject.isLoading = false
        this.sharedService.toast({
          title: this.translate.instant('error'),
          message: this.translate.instant('toast_create_failed'),
          type: 'danger',
        });
      }
    })
  }
  changeStatus(id: any, status: any) {
    this.sharedService.callApi(`${this.shareObject.component}/change_status`, { id, status }).subscribe((res: any) => {
      if (res.success) {
        this.shareObject.items = this.shareObject.items.map((e: any) => {
          if (e.id == id) {
            e.status = status;
            e.statusText = status == 1 ? this.translate.instant('status_waiting') : status == 2 ? this.translate.instant('status_approved') : this.translate.instant('status_rejected');
          }
          return e;
        })
      } else {
        this.sharedService.toast({
          title: this.translate.instant('error'),
          message: this.translate.instant('toast_update_failed'),
          type: 'danger',
        });
      }
    })
  }
  @HostListener('document:keydown.escape', ['$event'])
  handleEscape(event: KeyboardEvent) {
    this.shareObject.filterBox = false;
  }
}
